export const REPORTS_LIST_UPDATE = 'UPDATE_REPORTS_LIST'
export const REPORTS_LIST_CLEAN = 'REPORTS_LIST_CLEAN'

export const REPORT_LOAD_TO_STATE = 'REPORT_LOAD_TO_STATE'
export const REPORT_REMOVE_FROM_STATE = 'REPORT_REMOVE_FROM_STATE'
